import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-coaching-blog',
  templateUrl: './business-coaching-blog.component.html',
  styleUrls: ['./business-coaching-blog.component.scss']
})
export class BusinessCoachingBlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
